"use strict";
/* Common */
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
/* Translation */
var TranslationLanguage;
(function (TranslationLanguage) {
    TranslationLanguage["En"] = "en";
    TranslationLanguage["Ru"] = "ru";
})(TranslationLanguage = exports.TranslationLanguage || (exports.TranslationLanguage = {}));
;
/* Billboards */
__export(require("./GeoMarks"));
/******************************/
/* Companies / Customers
/******************************/
__export(require("./ClientInfo"));
__export(require("./EmailInfo"));
__export(require("./PhoneInfo"));
/* SystemEvents */
__export(require("./SystemEvents"));
/* EmployeeBrandsInfo */
__export(require("./EmployeeBrandsInfo"));
/* RolesInfo */
__export(require("./RolesInfo"));
//# sourceMappingURL=index.js.map